const responseUrls = new WeakMap<object, string>();

export const fetchWithResponseUrl = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const response = await globalThis.fetch(input, init);
  if (typeof input === "object") {
    // Axios returns the original Request and discards the final URL when it wraps a response stream.
    responseUrls.set(input, response.url);
  }
  return response;
};

export const getFetchResponseUrl = (request?: object): string | undefined =>
  request ? responseUrls.get(request) : undefined;
